import secureLocalStorage from "react-secure-storage";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import React, { PureComponent } from "react";
import "../../Styles/RiskViews.scss";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import MitigationNameCell from "../Tenant/Component/MitigationNameCell";
import ColumnMenuFilterForAction from "./ColumnMenuFilterForAction";
import { CustomFieldSearchMenuForAction } from "./CustomFieldSearchMenuForAction";
import { SearchMenuForAction } from "./SearchMenuForAction";
import OriginalCompDate from "../Tenant/Component/OriginalCompDate";
import ProjCompDate from "../Tenant/Component/ProjCompDate";
import ActualCompDate from "../Tenant/Component/ActualCompDate";
import { formatNumber } from "@telerik/kendo-intl";
import * as moment from "moment";
import { Popup } from "@progress/kendo-react-popup";

import { ColumnMenuCheckboxFilter } from "./ColumnMenuCheckboxFilter";
const filterOperators= {
  'text': [
      { text: 'grid.filterContainsOperator', operator: 'contains' },
      { text: 'grid.filterNotContainsOperator', operator: 'doesnotcontain' },
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterStartsWithOperator', operator: 'startswith' },
      { text: 'grid.filterEndsWithOperator', operator: 'endswith' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' },
      // { text: 'grid.filterIsEmptyOperator', operator: 'isempty' },
      // { text: 'grid.filterIsNotEmptyOperator', operator: 'isnotempty' }
  ],
  'numeric': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterGteOperator', operator: 'gte' },
      { text: 'grid.filterGtOperator', operator: 'gt' },
      { text: 'grid.filterLteOperator', operator: 'lte' },
      { text: 'grid.filterLtOperator', operator: 'lt' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],
  'date': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
      { text: 'grid.filterNotEqOperator', operator: 'neq' },
      { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
      { text: 'grid.filterAfterOperator', operator: 'gt' },
      { text: 'grid.filterBeforeOperator', operator: 'lt' },
      { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
      { text: 'grid.filterIsNullOperator', operator: 'isnull' },
      { text: 'grid.filterIsNotNullOperator', operator: 'isnotnull' }
  ],
  'boolean': [
      { text: 'grid.filterEqOperator', operator: 'eq' },
  ]
}
export default class MitigationViewSelection extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sort: [],
      take: 10,//Math.round((window.innerHeight - 250) / 35),
      skip: 0,
      mitigationData: [],
      customFieldsmaster:[],
      riskTypemaster:[],
      mitigationDataTemp: [],
      impactMaster: [],
      selectedIds: [],
      existingFilter: [],
      // dropdownColumns:[],
      selectedColumn: undefined,
      filter: {
        logic: "and",
        filters: [],
      },
      sort: [],
      previousLength: 0
    };
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DDTHH:mm:ss");
    };
  }

  componentDidMount() {
    if (this.props.mitigationData && this.props.mitigationData.length > 0) {
      this.init();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.mitigationData !== prevProps.mitigationData) {
      this.setState(
        {
          existingFilter: [],
          filter: { logic: "and", filters: [] },
          skip: 0
        },
        () => {
          this.init();
        }
      );
    }
    Date.prototype.toJSON = function () {
      return moment(this).format("YYYY-MM-DDTHH:mm:ss");
    };

    const finalData = this.getFinalMitigationData();
    const currentLength = finalData.length;

    if (this.state.previousLength !== currentLength) {
      this.setState({previousTaskIds: currentLength});
      if (this.state.skip >= currentLength) {
        this.setState({ skip: 0});
      }
    }
  }

  // getFinalMitigationData = () => {
  //   const { applyTopXFilter } = this.props;

  //   let data = [...this.props.mitigationData];

  //   if (this.props.filteredRiskIds?.length) {
  //     data = data.filter(item =>
  //       this.props.filteredRiskIds.includes(item.riskRegisterId)
  //     );
  //   }

  //   data = applyTopXFilter(data, "ACTION");
  //   return data;
  // };

  getFinalMitigationData = () => {
  const { applyTopXFilter } = this.props;

  let data = [...this.state.mitigationData];

  if (this.props.filteredRiskIds?.length) {
    data = data.filter(item =>
      this.props.filteredRiskIds.includes(item.riskRegisterId)
    );
  }

  data = applyTopXFilter(data, "ACTION");

  // Apply sorting if sort state exists
  if (this.state.sort && this.state.sort.length > 0) {
    data = orderBy(data, this.state.sort);
  }

  return data;
};

  init = async () => {
    // Create a copy of the data to avoid mutating props
    let mitigationDataCopy = [...this.props.mitigationData];
    
    await this.createDynamicDropdowns(mitigationDataCopy, []);
    await this.createDynamicCols(mitigationDataCopy, []);
    this.setState({
      ...this.state,
      customFieldsmaster:this.props.customFieldsmaster,
      riskTypemaster:this.props.riskTypemaster,
      sort: [],
      // existingFilter: [],
      // filter: {
      //   logic: "and",
      //   filters: [],
      // },
    });
  };


  //trigger method by parent
  updateFilter = () => {
    this.setState({
      ...this.state,
      existingFilter: [],
      filter: {
        logic: "and",
        filters: [],
      },
    });
  };

  
  checkRisktypeSelections = (exfilter) => {
    let temp = [];
    this.state.riskTypemaster.map((item) => {
      let checked = this.checkCFinFilterValuesOrNot(
        "riskTypeNames",
        item.hashValue,
        exfilter
      );
      item["checked"] = checked;
      temp.push(item);
    });
    this.setState({ ...this.state, riskTypemaster: temp });
  };


  createDynamicDropdowns = async (products,filter) => {
    try{
      let dropdownColumn = [];
      products.map((res, i) => {
        res.customFields &&
          res.customFields.map((item, j) => {
            if (dropdownColumn.length > 0) {
              if (!dropdownColumn.find((cf) => cf.fieldName == item.fieldName)) {
                dropdownColumn.push({
                  fieldName: item.fieldName,
                  data: this.getCustomFieldMasterData(item.fieldName,filter),
                  inputType: this.getInputType(item.fieldName),
                });
              }
            } else {
              dropdownColumn.push({
                fieldName: item.fieldName,
                data: this.getCustomFieldMasterData(item.fieldName,filter),
                inputType: this.getInputType(item.fieldName),
              });
            }
          });
      });
  
      if (dropdownColumn.length > 0) {
        products.map((res) => {
          dropdownColumn.map((col) => {
            let temp = res.customFields.find(
              (item) => item.fieldName === col.fieldName
            );
            if (temp) {
              if (temp.inputType === "Multi Drop Down") {
                let val = temp.selectedCustomFieldNames
                  ? temp.selectedCustomFieldNames.toString()
                  : "";
                let hashArr = this.stringToHashForCF(val, col.data);
                res[col.fieldName] = hashArr;
              } else if (temp.inputType === "Single Drop Down") {
                let val = temp.selectedCustomFieldNames&&temp.selectedCustomFieldNames.length>0
                  ? temp.selectedCustomFieldNames.toString()
                  : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Free Text") {
                let val = temp.multiText&& temp.multiText!="" ? temp.multiText : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Numeric") {
                let val = temp.multiText&& temp.multiText!="" ? parseInt(temp.multiText) : null;
                res[col.fieldName] = val;
              } else if (temp.inputType === "Date") {
                let val = temp.multiText&& temp.multiText!="" ? new Date(temp.multiText) : null;
                res[col.fieldName] = val;
              }
            } else {
              res[col.fieldName] = "";
            }
          });
        });
      }
      let columnsToShow = [];
      if (dropdownColumn.length > 0) {
        columnsToShow = dropdownColumn.map((item) => (
          <Column
            field={item.fieldName}
            title={item.fieldName}
            width="150px"
            editable={false}
            cell={(props) => this.viewMultiselectColsCustomDropdown(props, item)}
            columnMenu={(props) => this.getCustomFieldColumnMenu(props, item)}
            filter={this.getCustomFieldFilter(item)}
            headerClassName={this.checkItsinFilterOrNot(
              item.fieldName,
              filter
            )?"active":""}
          />
        ));
      }
      this.setState({
        ...this.state,
        dropdownColumns: columnsToShow,
        mitigationData: products,
        mitigationDataTemp: products
      });
    }catch(err){
      console.log(err);
    }
    
  };

  getCustomFieldFilter = (item) => {
    if (item.inputType === "Multi Drop Down") {
      return "";
    } else if (item.inputType === "Single Drop Down") {
      return "text";
    } else if (item.inputType === "Free Text") {
      return "";
    } else if (item.inputType === "Numeric") {
      return "numeric";
    } else if (item.inputType === "Date") {
      return "date";
    } else {
      return "";
    }
  };

  getCustomFieldColumnMenu = (props, item) => {
    if (item.inputType === "Multi Drop Down") {
      return (
        <CustomFieldSearchMenuForAction
          {...props}
          customFieldsmaster={item.data}
          existingFilter={this.state.existingFilter}
          filterChangeV={this.filterChangeV}
          clearFilter={this.clearFilter}
        />
      );
    }else if(item.inputType === "Single Drop Down"){
      return (                      
        <ColumnMenuCheckboxFilter
          {...props}
          data={this.getFinalMitigationData()}
          getSelectedColumn={this.getSelectedColumn}
        />
      )
    } else {
      return (
        <ColumnMenuFilterForAction
          {...props}
          getSelectedColumn={this.getSelectedColumn}
        />
      );
    }
  };
  getInputType = (fieldName) => {
    try {
      let arr = this.props.customFieldsmaster?.find(
        (item) => item.fieldName == fieldName
      );
      if (arr) {
        return arr.inputType;
      } else {
        return undefined;
      }
    } catch (err) {
      console.error(err);
    }
  };

  getCustomFieldMasterData = (fieldName,filter) => {
    try {
      let arr = this.props.customFieldsmaster?.filter(
        (item) => item.fieldName == fieldName
      );
      if (arr && arr.length > 0) {
        let temp = [];
        arr[0].cfPossibleValues.map((item, index) => {
          let checked=this.checkCFinFilterValuesOrNot(fieldName,item.hashValue,filter);
          temp.push({
            id: index,
            name: item.possibleValues,
            checked: checked,
            hashValue: item.hashValue,
          });
        });
        return temp;
      } else {
        return [];
      }
    } catch (err) {
      return [];
    }
  };

  stringToHashForCF(stringArr, data) {
    let hashArr = [];
    if (stringArr && stringArr.includes(",")) {
      let valArr = stringArr.split(",");
      valArr &&
        valArr.map((item1) => {
          let cfVal = data.find((item) => item.name == item1);
          if (cfVal) {
            hashArr.push(cfVal.hashValue);
          }
        });
    } else {
      let cfVal = data.find((item) => item.name == stringArr);
      if (cfVal) {
        hashArr.push(cfVal.hashValue);
      }
    }
    return hashArr.toString();
  }

  createDynamicCols = async (products,filter) => {
    try{
      let impactMaster = [];
      if (products && products.length > 0) {
        impactMaster = products[0].impactResponse;
      }
  
      let impactColumn = [];
  
      products.map((res, i) => {
        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.includes(item.name)) {
                impactColumn.push(item.name);
              }
            } else {
              impactColumn.push(item.name);
            }
          });
        }
      });
      
      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp = res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =
                temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;
            }
          });
        });
      }
      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={item}
            title={"Change in " + this.getImpactUnit(item, impactMaster)}
            width="100px"
            editable={false}
            filter={"numeric"}
            cell={(props) => (
              <CurrencyFormat {...props} onEditCell={this.onEditCell} />
            )}
            columnMenu={(props) => (
              <ColumnMenuFilterForAction
                {...props}
                getSelectedColumn={this.getSelectedColumn}
              />
            )}
            headerClassName={this.checkItsinFilterOrNot(
              item,
              filter
            )?"active":""}
          />
        ));
      }
      // var mitigationData = products.map((dataItem) =>
      //   Object.assign({ selected: false }, dataItem)
      // );
      this.setState({
        ...this.state,
        impactColumns: columnsToShow,
        mitigationData: products,
        mitigationDataTemp: this.props.mitigationDataTemp,
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
      });
    }catch(err){
      console.log(err);
    }
   
  };
  getImpactUnit = (impact, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == impact);
    var res = impact;
    if (
      impactTemp &&
      impactTemp.name &&
      impactTemp.impactType == "Quantitative"
    ) {
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return res;
  };

  dataStateChange = (event) => {
    // this.setState(this.createAppState(event.dataState));
    // this.props.mitigationFilterQuery(event.dataState);
  };

  createAppState = (dataState) => {
    if (this.state && this.state.mitigationDataTemp) {
      return {
        mitigationData: this.state.mitigationDataTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        mitigationData: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => {};
  selectionChange = (event) => {
    const data = this.state.mitigationData.map((item) => {
      if (item.riskRegisterActionId === event.dataItem.riskRegisterActionId) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.mitigationData.map((item) => {
      item.selected = checked;
      return item;
    });
    this.saveSelectedIds(data);
    this.setState({ data });
  };
  saveSelectedIds = (data) => {
    let listOfIds = [];
    for (let row of Object.values(data)) {
      if (row.selected) {
        listOfIds.push(row.riskRegisterActionId);
      }
    }
    this.setState({ selectedIds: listOfIds });
    this.props.getSelectedIds(listOfIds);
  };
  rowClick = (event) => {
    let last = this.lastSelectedIndex;
    const data = [...this.state.mitigationData];
    const current = data.findIndex((dataItem) => dataItem === event.dataItem);

    if (!event.nativeEvent.shiftKey) {
      this.lastSelectedIndex = last = current;
    }

    if (!event.nativeEvent.ctrlKey) {
      data.forEach((item) => (item.selected = false));
    }
    const select = !event.dataItem.selected;
    for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
      data[i].selected = select;
    }
    this.setState({ data });
  };

  sortChange = (event) => {
    this.setState({
      sort: event.sort,
    });
  };
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  getProducts = (sort) => {
    return orderBy(this.state.mitigationData, sort);
  };

  viewMultiselectColsRiskType = (event) => {
    let value = event.dataItem[event.field];
    let temp = [];

    if (value && value.includes(",")) {
      let arr = value.split(",");
      arr &&
        arr.map((item1, i) => {
          let originalValue = this.state.riskTypemaster.find(
            (item) => item.hashValue == item1
          );
          if (originalValue) {
            temp.push(originalValue.name);
          }
        });
    } else {
      let originalValue = this.state.riskTypemaster.find(
        (item) => item.hashValue == value
      );
      if (originalValue&&originalValue.name!=" [blank]") {
        temp.push(originalValue.name);
      }
    }
    return <td title={temp.toString()}>{temp.toString()}</td>;
  };

  viewMultiselectColsCustomDropdown = (event, cfObj) => {
    let data = cfObj.data;
    let value = event.dataItem[event.field];

    if (cfObj && cfObj.inputType === "Multi Drop Down") {
      let temp = [];
      if (value && value.includes(",")) {
        let arr = value.split(",");
        arr &&
          arr.map((item1, i) => {
            let originalValue = data.find((item) => item.hashValue === item1);
            if (originalValue) {
              temp.push(originalValue.name);
            }
          });
      } else {
        let originalValue = data.find((item) => item.hashValue === value);
        if (originalValue&&originalValue.name!=" [blank]") {
          temp.push(originalValue.name);
        }
      }
      return <td title={temp.toString()}>{temp.toString()}</td>;
    } else if (cfObj && cfObj.inputType === "Single Drop Down") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Free Text") {
      return (
        <td title={value ? value.toString() : ""}>
          {value ? value.toString() : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Numeric") {
      return (
        <td
          title={
            value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""
          }
        >
          {value || value === 0 ? formatNumber(parseInt(value), "##,#") : ""}
        </td>
      );
    } else if (cfObj && cfObj.inputType === "Date") {
      return (
        <td title={value ? moment(value).format("DD-MMM-YYYY") : ""}>
          {value ? moment(value).format("DD-MMM-YYYY") : ""}
        </td>
      );
    } else {
      return <td></td>;
    }
  };

  removeExistingFilter=(exi,colname)=>{
    try{

    }catch(err){

    }
  }

  filterChangeV = async (e, colname) => {
    try{
      let filteredExisting = [];
      if (this.state.existingFilter) {
        filteredExisting = this.state.existingFilter.filter(filter2 => {
          if (filter2.filters) {
            return !filter2.filters.some(innerFilter => innerFilter.field === colname);
          } else {
            return filter2.field !== colname;
          }
        });
      }
  
      let filter = e ? e.filters : [];
      let temp = [];
      if (filter.length > 0) {
        temp = [
          {
            filters: filter,
            logic: "or",
          },
        ];
      }
  
      let arr = [...filteredExisting, ...temp];
      const result = filterBy(this.state.mitigationDataTemp, arr);
      if (result && result.length > 0) {
      await this.createDynamicDropdowns(result,arr);
      await this.createDynamicCols(result,arr);
      await this.checkRisktypeSelections(arr);
      }
      var mitigationData = result.map((dataItem) =>
      Object.assign({ selected: false }, dataItem)
    );
    // mitigationData = this.props.filteredRiskIds.length > 0 ? mitigationData.filter(item => this.props.filteredRiskIds.includes(item.riskRegisterId)) : [];
      this.setState({
        ...this.state,
        mitigationData: mitigationData,
        existingFilter: arr,
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter:{
          logic: "and",
          filters: arr,
        },
      });
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(arr);
    }catch(err){
      console.error(err);
    }
  
  };
  clearFilter = async (e) => {
    try{
      let filter = e ? e : [];
      const result = filterBy(this.state.mitigationDataTemp, filter);
      await this.createDynamicDropdowns(result,filter);
      await this.createDynamicCols(result,filter);
      await this.checkRisktypeSelections(filter);
      var mitigationData = result.map((dataItem) =>
      Object.assign({ selected: false }, dataItem)
    );
    // mitigationData = this.props.filteredRiskIds.length > 0 ? mitigationData.filter(item => this.props.filteredRiskIds.includes(item.riskRegisterId)) : [];
      this.setState({
        ...this.state,
        mitigationData: mitigationData,
        existingFilter: filter,
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        skip: 0,
        sort: [],
        filter:{
          logic: "and",
          filters: filter,
        },
      });
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(filter);
    }catch(err){
      console.error(err);
    }
    
  };

  //trigered from parent
  clearFilterNew = async (e) => {
    try{
      let filter = e ? e : [];
      let exi = await this.changeDateValueFromFilters(filter);
      const result = filterBy(this.state.mitigationDataTemp, exi);
      await this.createDynamicDropdowns(result,filter);
      await this.createDynamicCols(result,filter);
      await this.checkRisktypeSelections(filter);
      var mitigationData = result.map((dataItem) =>
      Object.assign({ selected: false }, dataItem)
    );
    // mitigationData = this.props.filteredRiskIds.length > 0 ? mitigationData.filter(item => this.props.filteredRiskIds.includes(item.riskRegisterId)) : [];
      this.setState(
        {
          ...this.state,
          mitigationData: mitigationData,
          existingFilter: filter,
       take: 10,//Math.round((window.innerHeight - 250) / 35),
          skip: 0,
          sort: [],
          filter:{
            logic: "and",
            filters: filter,
          },
        },
       
      );
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(filter);
    }catch(err){
      console.error(err);
    }
    
  };

  checkItsinFilterOrNot = (field, exfilter) => {
    let headerClassName = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field) {
            headerClassName = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field) {
                headerClassName = true;
              }
            });
          }
        });
        return headerClassName;
      }
    } catch (err) {
      return headerClassName;
    }
  };

  
  checkCFinFilterValuesOrNot = (field,value, exfilter) => {
    let flag = false;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field&&filter.value==value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field&&innerFilter.value==value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };


  changeDateValueFromFilters = (exfilter) => {
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          let flag = moment(
            filter.value,
            "YYYY-MM-DDTHH:mm:ss",
            true
          ).isValid();
          // if (filter.field === "updatedDate"||
          // filter.field === "createdDate"||
          // filter.field === "actualCompletionDate"||
          // filter.field === "originalCompletionDate" ||
          // filter.field === "projectedCompletionDate"||
          // filter.field === "proximityDate") {
          if (flag) {
            filter["value"] = new Date(filter.value);
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              let flag = moment(
                innerFilter.value,
                "YYYY-MM-DDTHH:mm:ss",
                true
              ).isValid();

              // if (
              //   innerFilter.field === "updatedDate" ||
              //   innerFilter.field === "createdDate" ||
              //   innerFilter.field === "actualCompletionDate" ||
              //   innerFilter.field === "originalCompletionDate" ||
              //   innerFilter.field === "projectedCompletionDate" ||
              //   innerFilter.field === "proximityDate"
              // ) {
              if (flag) {
                innerFilter["value"] = new Date(innerFilter.value);
              }
            });
          }
        });
        return exfilter;
      }
    } catch (err) {}
    return exfilter;
  };
  filterChangeExisting = async (e) => {
    if (e.nativeEvent.type == "submit") {
      const newFilterFields = new Set();
      let filter = e.filter ? e.filter.filters : [];
      
      if (filter && filter.length > 0) {
        filter.forEach(filterItem => {
          if (filterItem.filters) {
            filterItem.filters.forEach(innerFilter => {
              if (innerFilter.field) {
                newFilterFields.add(innerFilter.field);
              }
            });
          } else if (filterItem.field) {
            newFilterFields.add(filterItem.field);
          }
        });
      }
      
      // Remove any existing filters for the same fields
      let existingFilter = this.state.existingFilter ? this.state.existingFilter : [];
      let filteredExisting = existingFilter.filter(item => {
        // For filters with nested filters array
        if (item.filters) {
          return !item.filters.some(innerFilter =>
            innerFilter.field && newFilterFields.has(innerFilter.field)
          );
        }
        // For direct filters
        return !(item.field && newFilterFields.has(item.field));
      });
      
      let arr = [...filteredExisting, ...filter];
      const result = filterBy(this.state.mitigationDataTemp, arr);
      if (result && result.length > 0) {
      await this.createDynamicDropdowns(result,arr);
      await this.createDynamicCols(result,arr);
      await this.checkRisktypeSelections(arr);
      }
      var mitigationData = result.map((dataItem) =>
      Object.assign({ selected: false }, dataItem)
    );
    // mitigationData = this.props.filteredRiskIds.length > 0 ? mitigationData.filter(item => this.props.filteredRiskIds.includes(item.riskRegisterId)) : [];
      this.setState({
        ...this.state,
        mitigationData: mitigationData,
        existingFilter: arr,
        take: 10,//Math.round((window.innerHeight - 250) / 35),
        sort: [],
        filter:{
          logic: "and",
          filters: arr,
        },
        skip: 0,
      });
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(arr);
    } else if (e.nativeEvent.type == "reset") {
      let exi = [];
      if (this.state.existingFilter) {
        let filterData = this.state.existingFilter;
        filterData.forEach((filter2) => {
          if (filter2.filters) {
            // Check if any inner filter matches the selected column
            const hasMatchingInnerFilter = filter2.filters.some(
              innerFilter => innerFilter.field === this.state.selectedColumn
            );
            // Only add the filter if none of its inner filters match the selected column
            if (!hasMatchingInnerFilter) {
              exi.push(filter2);
            }
          } else {
            // For direct filters, only add if field doesn't match selected column
            if (filter2.field !== this.state.selectedColumn) {
              exi.push(filter2);
            }
          }
        });
      }
      const result = filterBy(this.state.mitigationDataTemp, exi);
      await this.createDynamicDropdowns(result,exi);
      await this.createDynamicCols(result,exi);
      await this.checkRisktypeSelections(exi);
      var mitigationData = result.map((dataItem) =>
      Object.assign({ selected: false }, dataItem)
    );
    // mitigationData = this.props.filteredRiskIds.length > 0 ? mitigationData.filter(item => this.props.filteredRiskIds.includes(item.riskRegisterId)) : [];
      this.setState(
        {
          ...this.state,
          mitigationData: mitigationData,
          existingFilter: exi,
          take: 10,//Math.round((window.innerHeight - 250) / 35),
          skip: 0,
          sort: [],
          filter:{
            logic: "and",
            filters: exi,
          },
        },
       
      );
      this.saveSelectedIds([]);
      this.props.mitigationFilterQuery(exi);
    }
  };

  getSelectedColumn = (col) => {
    if (col != this.state.selectedColumn) {
      this.setState({ ...this.state, selectedColumn: col });
    }
  };

  removeSelectedFilterInExisting = () => {
    let exi = [];
    if (this.state.existingFilter) {
      let filterData = this.state.existingFilter;
      filterData.map((filter2) => {
        if (filter2.filters) {
          filter2.filters.map((innerFilter) => {
            if (innerFilter.field != this.state.selectedColumn) {
              exi.push(filter2);
            }
          });
        } else {
          if (filter2.field != this.state.selectedColumn) {
            exi.push(filter2);
          }
        }
      });
    }
    return exi;
  };
  
  setClassName = (field) => {
    let headerClassName = "";
    if (this.state.filter && this.state.filter.filters) {
      this.state.filter.filters.map((filter) => {
        if (filter.field === field) {
          headerClassName = "active";
        }
        if (filter.filters) {
          filter.filters.map((innerFilter) => {
            if (innerFilter.field === field) {
              headerClassName = "active";
            }
          });
        }
      });
    }
    return headerClassName;
  };
  progressHistory = (dataItem) => {
    this.setState({ ...this.state, progressStatusFlag: true,actionImpactComments: dataItem.actionImpactComments});
  };

  closeProgressHistoryPopup = () => {
    this.setState({ ...this.state, progressStatusFlag: false,actionImpactComments: []});
  };
  render() {
    const gridData = this.getFinalMitigationData();
    return (
      <div className="riskViewCont">
        <div
          className="tblCont riskRegister dataGrids ActionTbl"
          id="datasetaction"
        >
          <Grid
            data={filterBy(gridData, this.state.filter).slice(
              this.state.skip,
              this.state.take + this.state.skip
            )}
            {...this.state.dataState}
            onDataStateChange={this.dataStateChange}
            selectedField="selected"
            onSelectionChange={this.selectionChange}
            onHeaderSelectionChange={this.headerSelectionChange}
            // onRowClick={this.rowClick}
            filterOperators={filterOperators}
            reorderable={gridData.length==0?false:true}
            resizable={gridData.length==0?false:true}
            pageable={true}
            // total={this.state.mitigationData.length}
            sortable={{
              allowUnsort: true,
              mode: "multiple",
            }}
            sort={this.state.sort}
            onSortChange={this.sortChange}
            total={
              filterBy(gridData, this.state.filter).length
            }
            skip={this.state.skip}
            take={this.state.take}
            onPageChange={this.pageChange}
            onFilterChange={this.filterChangeExisting}
            filter={this.state.filter}
          >
            <GridNoRecords>
              {this.props.isCustomFieldDeleted
                ? "Associated Dataset's Custom fields might been deleted or revoked"
                : this.props.isImpactDeleted
                ? "Associated Dataset's Impact fields might been deleted or revoked"
                : "No records available"}
            </GridNoRecords>
            <Column
              field="selected"
              locked={true}
              width="42px"
              headerSelectionValue={
                gridData.findIndex(
                  (dataItem) => dataItem.selected === false
                ) === -1
              }
            />
            <Column
              field="organisationName"
              title="Workstream"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("organisationName")}
            />
            

            <Column
              field="riskNumber"
              title="Risk Number"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("riskNumber")}
            />

            {/* <Column
              field="riskTitle"
              title="Risk Title"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("riskTitle")}
            /> */}
            <Column
              field="riskName"
              title="Risk Description"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("riskName")}
            />

            <Column
              field="isOpportunity"
              title="T/O"
              width="100px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={this.state.mitigationData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) =>
                props.dataItem.isOpportunity === "Threat" ? (
                  <td>{props.dataItem.isOpportunity}</td>
                ) : (
                  <td>
                    <span className="turquoiseBlue">
                      {props.dataItem.isOpportunity}
                    </span>
                  </td>
                )
              }
              headerClassName={this.setClassName("isOpportunity")}
            />
            <Column
              field="name"
              locked={true}
              title="Action Title"
              width="200px"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              // cell={(props) => (
              //   <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              // )}
              headerClassName={this.setClassName("name")}
            />
            <Column
              field="number"
              title="Action Number"
              width="120px"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("number")}
            />
            <Column
              field="approved"
              title="Approved"
              width="100px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={gridData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("approved")}
            />
            <Column
              field="control"
              title="Description"
              width="120px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("control")}
            />
            <Column
              field="externalReference"
              title="External Reference"
              width="120px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("externalReference")}
            />
            <Column
              field="actionType"
              title="Action Type"
              width="120px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={gridData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("actionType")}
            />
            <Column
              field="riskTypeNames"
              title="Risk Type"
              width="150px"
              cell={this.viewMultiselectColsRiskType}
              columnMenu={(props) => (
                <SearchMenuForAction
                  {...props}
                  existingFilter={this.state.existingFilter}
                  data={this.state.riskTypemaster}
                  filterChangeV={this.filterChangeV}
                  clearFilter={this.clearFilter}
                />
              )}
              headerClassName={this.setClassName("riskTypeNames")}
            />

            {this.state.dropdownColumns}
            <Column
              field="cost"
              title={"Cost of Action / " + secureLocalStorage.getItem("currency")}
              width="80px"
              filter={"numeric"}
              cell={(props) => (
                <CurrencyFormat {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("cost")}
            />
            <Column
              field="reductionFrequency"
              width="80px"
              title="Change in Probability (%)"
              filter={"numeric"}
              cell={(props) => (
                <CurrencyFormat {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("reductionFrequency")}
            />

            {this.state.impactColumns}
            <Column
              field="spi"
              title="% On Track"
              width="80px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("spi")}
            />
            <Column
              field="percentageCompletion"
              title="% Completion"
              width="100px"
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("percentageCompletion")}
            />
            <Column
              field="originalCompletionDate"
              width="100px"
              title="Original Completion Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <OriginalCompDate {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("originalCompletionDate")}
            />
            <Column
              field="projectedCompletionDate"
              width="100px"
              title="Projected Completion Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <ProjCompDate {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("projectedCompletionDate")}
            />
            <Column
              field="actualCompletionDate"
              width="100px"
              title="Actual Completion Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              cell={(props) => (
                <ActualCompDate {...props} onEditCell={this.onEditCell} />
              )}
              headerClassName={this.setClassName("actualCompletionDate")}
            />
            <Column
              field="proximityDate"
              title="Proximity Date"
              width="100px"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("proximityDate")}
            />
            <Column
              field="daysOverdue"
              title="Original Days Overdue"
              width="120px"
              editable={false}
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("daysOverdue")}
            />
            <Column
              field="projectedOverdueActionCount"
              title="Projected Days Overdue"
              width="120px"
              editable={false}
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("projectedOverdueActionCount")}
            />
            <Column
              field="owner"
              title="Owner"
              width="100px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={gridData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("owner")}
            />
            <Column
              field="actionFieldsCompletion"
              title="% of fields completed"
              width="120px"
              editable={false}
              filter={"numeric"}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("actionFieldsCompletion")}
            />
            <Column
              width="100px"
              field="status"
              title="Progress Status"
              editable={false}
              cell={(props) => (
                <td title={props.dataItem.status}>
                  <span onClick={() => this.progressHistory(props.dataItem)}>
                    {props.dataItem.status}
                  </span>
                </td>
              )}
            />

            
            <Column
              field="createdDate"
              width="100px"
              title="Created Date"
              filter={"date"}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              // cell={(props) => (
              //   <td>{ moment(props.dataItem.createdDate).format('DD-MMM-YYYY')}</td>
              // )}
              headerClassName={this.setClassName("createdDate")}
            />
            <Column
              field="createdByName"
              width="100px"
              title="Created By"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={gridData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("createdByName")}
            />
            <Column
              field="updatedDate"
              title="updated Date"
              width="120px"
              editor="date"
              filter={"date"}
              editable={false}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              // cell={(props) => (
              //   <td>{ moment(props.dataItem.updatedDate).format('DD-MMM-YYYY')}</td>
              // )}
              headerClassName={this.setClassName("updatedDate")}
            />
            <Column
              field="updatedBy"
              title="updated By"
              width="120px"
              editable={false}
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={gridData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("updatedBy")}
            />
            <Column
              field="isOpen"
              title="Status"
              width="80px"
              columnMenu={(props) => (
                <ColumnMenuCheckboxFilter
                  {...props}
                  data={gridData}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("isOpen")}
            />
            <Column
              field="closedDate"
              title="closed Date"
              width="120px"
              editor="date"
              filter={"date"}
              editable={false}
              format="{0:dd-MMM-yyyy}"
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("closedDate")}
            />
            <Column
              field="departments"
              title="Departments"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("departments")}
            />
            <Column
              field="externalStatus"
              title="External Status"
              width="120px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("externalStatus")}
            />
            <Column
              field="weeklyReport"
              title="Weekly Report"
              width="100px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
              columnMenu={(props) => (
                <ColumnMenuFilterForAction
                  {...props}
                  getSelectedColumn={this.getSelectedColumn}
                />
              )}
              headerClassName={this.setClassName("weeklyReport")}
            />
          </Grid>
        </div>

        <Popup
          show={this.state.progressStatusFlag}
          popupClass={"popup-content popup-wrapper"}
        >
          <div className="deleteModelCont stackHolderSelection">
            <label className="fieldLabel">Progress History</label>
            <div className="commentsHistory">
              <ul className="comments">
                {this.state.actionImpactComments &&
                  this.state.actionImpactComments.map((item) => (
                    <li>
                      <p>{item.actionComment}</p>
                      <small>
                        Date:
                        {moment(new Date(item.createdDate)).format(
                          "DD-MMM-yyyy HH:mm:ss"
                        )}
                      </small>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <small>Entered by:{item.userName}</small>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="progressBtn">
              <button
                onClick={this.closeProgressHistoryPopup}
                className="redbtn"
                type="button"
                style={{ "margin-left": "700px", "margin-bottom": "15px" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
